import React from 'react';
import { Control, UseControllerProps, useController } from 'react-hook-form';
import { PersonalizationFormValues } from '../types';
import { StyledInput } from '../Form/InputFields/InputFields.styles';

export function MessageLine({
  name,
  control,
  ...props
}: {
  name: UseControllerProps<PersonalizationFormValues>['name'];
  control: Control<PersonalizationFormValues>;
} & React.ComponentProps<'input'>) {
  const {
    field: { value, ...other },
  } = useController({
    name,
    control,
  });

  return <StyledInput {...props} {...other} value={typeof value === 'string' ? value : ''} />;
}
